import React, {useMemo} from 'react';

import {NotesSection} from 'src/components/notes-section';
import {useAdminAccessRight} from 'src/hooks/access-rights';
import {useEventTracking} from 'src/hooks/useEventTracking';

import {useAccountNotes} from './useAccountNotes';

type Props = {
    accountId: number,
};

export const AccountNotesSection: React.FC<Props> = ({accountId}) => {
    const {
        isLoading: accountNotesLoading,
        loadingError: accountNotesLoadingError,
        isChanged: isAccountNotesChanged,

        data: accountNotes,
        setData: setAccountNotes,

        saveChanges: saveAccountsNotes,
        discardChanges: discardAccountNotes,
    } = useAccountNotes({accountId});

    const {canEditAccountNotes} = useAdminAccessRight();
    const {accountSubmit, accountFieldChange} = useEventTracking();

    const canEdit = useMemo(() => (
        canEditAccountNotes(accountId)
    ), [accountId, canEditAccountNotes]);

    return (
        <NotesSection
            headline="Account Notes"
            isLoading={accountNotesLoading}
            canEdit={canEdit}
            loadingError={accountNotesLoadingError}
            notes={accountNotes?.value || ''}
            onChange={data => {
                accountFieldChange({
                    parameterName: 'Account Notes',
                    section: 'Account Notes',
                    viewType: 'Existed',
                });
                return setAccountNotes(data);
            }}
            onSave={() => {
                accountSubmit({place: 'Account Notes', submit: true});
                return saveAccountsNotes();
            }}
            onDiscard={() => {
                accountSubmit({place: 'Account Notes', submit: false});
                discardAccountNotes();
            }}
            isNotesChanged={isAccountNotesChanged}
            chunk="account-notes"
        />
    );
};
